(function () {

  function initMoreMenu() {

    var menu = document.querySelector('.thb-full-menu');
    if (!menu) return;

    var fullMenu = menu.closest('full-menu');
    if (fullMenu && fullMenu.getAttribute('data-enable-more-menu') === 'false') {
      menu.dataset.moreReady = 'true';
      return;
    }

    // Prevent duplicate init
    if (menu.dataset.moreInit === 'true') return;
    menu.dataset.moreInit = 'true';

    // Remove existing More menu if exists
    var existingMore = menu.querySelector('.more-menu-item');
    if (existingMore) existingMore.remove();

    // Create More menu item
    var moreLi = document.createElement('li');
    moreLi.className = 'more-menu-item';
    moreLi.setAttribute('role', 'menuitem');
    moreLi.style.cssText = 'position:relative;display:none;align-items:center;';

    moreLi.innerHTML =
      '<a href="javascript:void(0)"' +
      '   class="thb-full-menu--link more-submenu"' +
      '   aria-haspopup="true"' +
      '   aria-expanded="false">' +
      '  More' +
      '  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '    <path d="M6.75 1.5L3.75 4.5L0.75 1.5" stroke="var(--color-header-links, --color-accent)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>' +
      '  </svg>' +
      '</a>' +
      '<ul class="more-menu-dropdown" role="menu"></ul>';

    menu.appendChild(moreLi);

    var moreDropdown = moreLi.querySelector('.more-menu-dropdown');
    var moreToggle = moreLi.querySelector('.more-submenu');
    if (!moreDropdown || !moreToggle) return;

    // ── Open / Close ──────────────────────────────────────────

    function openMore() {
      moreLi.classList.add('is-open');
      moreDropdown.style.display = 'block';
      moreToggle.setAttribute('aria-expanded', 'true');
    }

    function closeMore() {
      moreLi.classList.remove('is-open');
      moreDropdown.style.display = 'none';
      moreToggle.setAttribute('aria-expanded', 'false');
    }

    moreLi.addEventListener('mouseenter', openMore);
    moreLi.addEventListener('mouseleave', closeMore);

    moreToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      moreLi.classList.contains('is-open') ? closeMore() : openMore();
    });

    document.addEventListener('click', function (e) {
      if (!moreLi.contains(e.target)) closeMore();
    });

    // ── Link extraction ───────────────────────────────────────
    // Walks any submenu/mega-menu DOM and returns a plain array:
    //   [{ title, url, children: [{ title, url, children }] }]

    var RIGHT_ARROW_SVG =
      '<svg class="more-flyout-arrow" width="6" height="8" viewBox="0 0 6 8" fill="none" ' +
      'xmlns="http://www.w3.org/2000/svg"><path d="M1.5 0.75L4.5 3.75L1.5 6.75" ' +
      'stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function extractLinks(el) {
      var links = [];

      // ── Standard mega menu / promotions  (.mega-menu-columns > li)
      var megaCols = el.querySelectorAll('.mega-menu-columns > li');
      if (megaCols.length) {
        megaCols.forEach(function (col) {
          var heading = col.querySelector(':scope > a');
          var item = {
            title: heading ? heading.textContent.trim() : '',
            url: heading ? (heading.getAttribute('href') || '#') : '#',
            children: []
          };
          col.querySelectorAll(':scope > ul > li > a').forEach(function (a) {
            item.children.push({
              title: a.textContent.trim(),
              url: a.getAttribute('href') || '#',
              children: []
            });
          });
          links.push(item);
        });
        return links;
      }

      // ── Collections mega menu  (.mega-menu-collection-card)
      var cards = el.querySelectorAll('.mega-menu-collection-card');
      if (cards.length) {
        cards.forEach(function (card) {
          var t = card.querySelector('.mega-menu-collection-card__title');
          links.push({
            title: t ? t.textContent.trim() : '',
            url: card.getAttribute('href') || '#',
            children: []
          });
        });
        return links;
      }

      // ── Sidebar mega menu  (<mega-menu-sidebar>)
      var sidebar = el.querySelector('mega-menu-sidebar');
      if (sidebar) {
        var buttons = sidebar.querySelectorAll('.mega-menu-sidebar--button');
        var panels = sidebar.querySelectorAll('.mega-menu-sidebar--content-inner');
        buttons.forEach(function (btn, i) {
          var span = btn.querySelector('span');
          var item = {
            title: span ? span.textContent.trim() : btn.textContent.trim(),
            url: btn.getAttribute('href') || '#',
            children: []
          };
          if (panels[i]) {
            panels[i].querySelectorAll(':scope > li').forEach(function (li) {
              var a = li.querySelector('a');
              if (a) {
                var label = a.querySelector('.text-button') || a;
                item.children.push({
                  title: label.textContent.trim(),
                  url: a.getAttribute('href') || '#',
                  children: []
                });
              }
            });
          }
          links.push(item);
        });
        return links;
      }

      // ── Regular sub-menu  (ul > li)
      el.querySelectorAll(':scope > li').forEach(function (li) {
        var a = li.querySelector(':scope > a');
        var item = {
          title: a ? a.textContent.trim() : '',
          url: a ? (a.getAttribute('href') || '#') : '#',
          children: []
        };
        var nested = li.querySelector(':scope > .sub-menu');
        if (nested) item.children = extractLinks(nested);
        links.push(item);
      });
      return links;
    }

    // ── Build simple dropdown UL from link data ───────────────

    function buildDropdown(data) {
      var currentUrl = window.location.href.split('?')[0].split('#')[0];
      var ul = document.createElement('ul');
      ul.className = 'more-flyout-menu';

      data.forEach(function (item) {
        var li = document.createElement('li');
        if (item.children.length) li.className = 'has-children';

        var a = document.createElement('a');
        a.href = item.url;
        a.className = 'thb-full-menu--link';
        if (item.children.length) {
          a.innerHTML = item.title + ' ' + RIGHT_ARROW_SVG;
        } else {
          a.textContent = item.title;
        }

        // ── Mark li active if link matches current page (li only, not <a>) ──
        var resolved = a.href.split('?')[0].split('#')[0];
        if (resolved === currentUrl && item.url !== '#' && item.url !== 'javascript:void(0)') {
          li.classList.add('active');
        }

        li.appendChild(a);

        if (item.children.length) {
          var childUl = buildDropdown(item.children);
          li.appendChild(childUl);

          // ── Bubble up: if any child li is active, mark parent li active too ──
          if (childUl.querySelector('li.active')) {
            li.classList.add('active');
          }
        }

        ul.appendChild(li);
      });
      return ul;
    }
    // ── Process items after they are moved into More dropdown ──

    function processMoreItems() {
      moreDropdown.querySelectorAll(':scope > li').forEach(function (li) {
        li.setAttribute('data-inside-more', 'true');

        var hasChildren = li.classList.contains('menu-item-has-children');
        var hasMega = li.classList.contains('menu-item-has-megamenu');
        if (!hasChildren && !hasMega) return;

        // Find original submenu / mega-menu
        var original = li.querySelector(':scope > .sub-menu, :scope > .mega-menu-container');
        if (!original) return;

        // Remove any previously created flyout
        var old = li.querySelector(':scope > .more-flyout-menu');
        if (old) old.remove();

        // Extract link hierarchy
        var data = extractLinks(original);
        if (!data.length) return;

        // Hide original (prevent theme CSS from showing it)
        original.style.display = 'none';
        original.style.visibility = 'hidden';
        original.setAttribute('data-more-hidden', 'true');

        // Append simple flyout dropdown
        li.appendChild(buildDropdown(data));
      });
      // ── Also handle direct links (no submenu) inside the More dropdown ──
      moreDropdown.querySelectorAll(':scope > li').forEach(function (li) {
        var directLink = li.querySelector(':scope > a');
        if (directLink) {
          var currentUrl = window.location.href.split('?')[0].split('#')[0];
          var resolved = directLink.href.split('?')[0].split('#')[0];
          var href = directLink.getAttribute('href');
          if (resolved === currentUrl && href !== '#' && href !== 'javascript:void(0)') {
            directLink.classList.add('active');
            li.classList.add('active');
          }
        }
      });

      // ── Mark moreLi active if any item inside is active ──
      if (moreDropdown.querySelector('.active')) {
        moreLi.classList.add('active');
      } else {
        moreLi.classList.remove('active');
      }
    }

    // ── Restore items before moving them back to the main nav ─

    function restoreItems() {
      moreDropdown.querySelectorAll(':scope > li').forEach(function (li) {
        // Remove generated flyout
        var flyout = li.querySelector(':scope > .more-flyout-menu');
        if (flyout) flyout.remove();

        // Restore original submenu visibility
        var hidden = li.querySelector('[data-more-hidden]');
        if (hidden) {
          hidden.style.display = '';
          hidden.style.visibility = '';
          hidden.removeAttribute('data-more-hidden');
        }
        li.removeAttribute('data-inside-more');
      });
      moreLi.classList.remove('active');
    }

    // ── Main overflow logic ───────────────────────────────────

    function adjustMenu() {
      var currentFullMenu = document.querySelector('full-menu');
      if (currentFullMenu && currentFullMenu.getAttribute('data-enable-more-menu') === 'false') {
        var currentMenu = document.querySelector('.thb-full-menu');
        if (currentMenu) {
          currentMenu.dataset.moreReady = 'true';
        }
        return;
      }

      // Restore before moving back
      restoreItems();

      var dropdownChildren = [].slice.call(moreDropdown.children);
      dropdownChildren.forEach(function (item) {
        item.removeAttribute('data-inside-more');
        menu.insertBefore(item, moreLi);
      });

      moreLi.style.display = 'none';
      closeMore();

      var menuWidth = menu.offsetWidth;
      var totalWidth = 80; // reserve for More button

      var items = [].slice.call(menu.children).filter(function (item) {
        return item !== moreLi;
      });

      items.forEach(function (item) {
        totalWidth += item.offsetWidth;
        if (totalWidth > menuWidth) {
          moreLi.style.display = 'inline-flex';
          moreDropdown.appendChild(item);
        }
      });

      if (!moreDropdown.children.length) {
        moreLi.style.display = 'none';
      } else {
        processMoreItems();
      }

      // Re-trigger FullMenu resizeSubMenus for remaining items
      var fullMenuEl = document.querySelector('full-menu');
      if (fullMenuEl && typeof fullMenuEl.resizeSubMenus === 'function') {
        fullMenuEl.resizeSubMenus();
      }

      // Mark the menu as ready/calculated to reveal it without layout shift
      menu.dataset.moreReady = 'true';
    }

    // ── Debounced resize ──────────────────────────────────────

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(adjustMenu, 100);
    });

    // ── Initial run ───────────────────────────────────────────

    // Run the calculation immediately to show the navigation as fast as possible
    adjustMenu();

    // Re-run the calculation when fonts are ready to handle font-size width changes
    if (document.fonts && typeof document.fonts.ready !== 'undefined') {
      document.fonts.ready.then(function () {
        adjustMenu();
      });
    }

    // Safety/fallback run on window load
    if (document.readyState === 'complete') {
      adjustMenu();
    } else {
      window.addEventListener('load', adjustMenu);
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoreMenu);
  } else {
    initMoreMenu();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function () {
    var m = document.querySelector('.thb-full-menu');
    if (m) delete m.dataset.moreInit;
    initMoreMenu();
  });

})();

/**
 * Third-party "Add to Cart" → header cart count sync
 * ---------------------------------------------------
 * The third-party wishlist/product-card app adds items via its own
 * POST /cart/add(.js) and refreshes the cart drawer (GET ?sections=cart-drawer),
 * but it never updates the theme's header count bubble (.thb-item-count inside
 * #cart-drawer-toggle).
 *
 * Strategy: observe (never replace the result of) fetch/XHR. After a successful
 * /cart/add that the THEME did not already handle, re-render the theme's own
 * `cart-bubble` section once and copy its count markup into every count bubble.
 * This mirrors the theme's native update (assets/app.js → renderContents),
 * including the ">99 → asterisk" markup.
 *
 * The theme's own adds (product form / quick-add / quick-view) already update
 * the bubble and then dispatch `cart:item-added`; we detect that and skip our
 * fetch, so native flows do zero extra work. The app's adds never dispatch it.
 */
(function () {
  'use strict';

  var COUNT_SELECTOR = '.thb-item-count';
  var ADD_URL = /\/cart\/add(\.js)?(\?|$)/;  // Shopify add-to-cart endpoint
  var THEME_HANDLED_MS = 1000;               // window in which a theme add counts as "already handled"

  var timer, controller, lastThemeAdd = 0;

  // The theme fires this after its own successful adds; record the time so the
  // debounced sync can bow out and avoid a redundant section render.
  document.addEventListener('cart:item-added', function () { lastThemeAdd = Date.now(); });

  // Locale/market-aware base path (e.g. "/", "/en-ca/"); falls back to root.
  function sectionsBase() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root;
    return root || '/';
  }

  // Re-render cart-bubble and copy its count markup into every bubble.
  // Debounced (rapid adds -> one fetch) and aborts any in-flight sync so the
  // most recent add wins.
  function syncCartCount() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (Date.now() - lastThemeAdd < THEME_HANDLED_MS) return; // theme already updated it

      if (controller) controller.abort();
      controller = new AbortController();

      fetch(sectionsBase() + '?sections=cart-bubble', {
        headers: { Accept: 'application/json' },
        signal: controller.signal
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var html = data && data['cart-bubble'];
          if (!html) return;
          var fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(COUNT_SELECTOR);
          if (!fresh) return;
          var markup = fresh.innerHTML;
          document.querySelectorAll(COUNT_SELECTOR).forEach(function (el) {
            if (el.innerHTML !== markup) el.innerHTML = markup;
          });
        })
        .catch(function () { /* aborted or network/parse error — ignore */ });
    }, 150);
  }

  function onAddComplete(ok) { if (ok) syncCartCount(); }

  // --- Wrap fetch (observe only; result is returned untouched) ------------
  if (window.fetch && !window.fetch.__cartSync) {
    var origFetch = window.fetch;
    var wrapped = function (input) {
      var url = (typeof input === 'string' || input instanceof URL) ? input : (input && input.url);
      var promise = origFetch.apply(this, arguments);
      if (ADD_URL.test(String(url || ''))) {
        promise.then(function (res) { onAddComplete(res && res.ok); }, function () { });
      }
      return promise;
    };
    wrapped.__cartSync = true;
    window.fetch = wrapped;
  }

  // --- Wrap XMLHttpRequest (some apps still use XHR) ----------------------
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__cartSync) {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartAdd = ADD_URL.test(String(url || ''));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__cartAdd) {
        this.addEventListener('load', function () {
          onAddComplete(this.status >= 200 && this.status < 300);
        });
      }
      return send.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__cartSync = true;
  }
})();

//Add Title attribute for wishlist icon 
// Just the one-liner version if the app always loads before your script
document.querySelector('.wh-trigger')?.setAttribute('title', 'My Wishlist');

// Fallback trigger for the search drawer trigger links (.thb-quick-search)
document.addEventListener('click', function (e) {
  if (e.defaultPrevented) return;
  var trigger = e.target.closest('.thb-quick-search');
  if (trigger) {
    var drawer = document.getElementById('Search-Drawer');
    if (drawer && window.OverlayManager) {
      e.preventDefault();
      if (!window.OverlayManager.isOpen(drawer)) {
        window.OverlayManager.open(drawer);
        setTimeout(function () {
          var input = drawer.querySelector('input[type="search"]');
          if (input) {
            input.focus({ preventScroll: true });
            if (input.value) {
              var len = input.value.length;
              input.setSelectionRange(len, len);
            }
          }
        }, 100);
        document.dispatchEvent(new CustomEvent('search:open'));
      }
    }
  }
});
